import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingCircle from 'components/ui/LoadingCircle';
import { Document } from './Document';

export function DocumentsList({
  isOrder,
  documents,
  deleteDisabled,
  onDeleteConfirm,
  onDeleteDecline,
  sentDocuments,
  loading,
}) {
  const { t } = useTranslation();
  const entity = isOrder ? 'order' : 'shipment';

  if (loading) {
    return <LoadingCircle text={t('LOADING')} />;
  }

  if (!documents || documents.length === 0) {
    return <i>{t('THIS_ENTITY_HAS_NO_DOCUMENTS', { entity })}</i>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="default-table">
        <thead>
          <tr>
            <th>{t('DOCUMENT')}</th>
            <th>{t('DATE_one')}</th>
            <th>{t('SIGNATORY')}</th>
            <th>{t('STATUS')}</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {documents.map((document, index) => (
            <Document
              key={document.id || index}
              isOrder={isOrder}
              document={document}
              deleteDisabled={deleteDisabled}
              onDeleteConfirm={onDeleteConfirm}
              onDeleteDecline={onDeleteDecline}
              isSent={Boolean(
                sentDocuments.find((doc) => doc.id === document.id),
              )}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
